import { render, staticRenderFns } from "./CustomerBalance.vue?vue&type=template&id=84a0b53e&"
import script from "./CustomerBalance.vue?vue&type=script&lang=js&"
export * from "./CustomerBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports